export default __webpack_public_path__ + "static/media/icon-google.ecf357c5.png";